import { useFetchValidationSchema } from 'app/utils/hooks';
import { useMemo } from 'react';
import { transformSchemaToYup } from 'app/utils/schemaToYup';
import { defaultValues } from 'app/components/Releases/ExportSoundCloudReleaseDialog/constants';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { SingleTrackExportFormValues } from 'app/components/Releases/ExportSoundCloudReleaseDialog/types';
import { dynamicYupResolver } from 'app/utils/utils';
import { Link } from 'types/api.types';

interface UseSingleTrackReleaseExportFormProps {
  releaseExportLink?: Link;
  releaseTitle: string;
}

export const useSingleTrackReleaseExportForm = ({
  releaseExportLink,
  releaseTitle,
}: UseSingleTrackReleaseExportFormProps) => {
  const {
    validationSchema,
    validationSchemaFetched,
  } = useFetchValidationSchema({
    link: releaseExportLink,
  });

  const yupValidationSchema = useMemo(
    () =>
      validationSchemaFetched &&
      validationSchema &&
      transformSchemaToYup(validationSchema, {
        ...defaultValues,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [validationSchema, validationSchemaFetched]
  );

  const concatenatedSchema = yup
    .object()
    .shape({
      releaseExportDate: yup.date().nullable().typeError('Invalid Date Format'),
    })
    .concat(yupValidationSchema);

  return useForm<SingleTrackExportFormValues>({
    defaultValues: {
      ...defaultValues,
      title: releaseTitle,
    },
    mode: 'all',
    context: {
      yupValidationSchema: concatenatedSchema,
    },
    resolver: dynamicYupResolver,
  });
};
